import React from 'react'
import {FieldValues, UseFormRegister} from 'react-hook-form'
import {TooltipDanger, Tooltip} from 'hec/assets/icons'
import PasswordResetToolTip from './passwordResetToolTip'

type PasswordFieldProps<TFormValues extends FieldValues> = {
    id: string
    name: keyof TFormValues & string
    label: string
    register: UseFormRegister<TFormValues>
    disabled?: boolean
    showNewPassword: boolean
    onToggleShow: () => void
    errorMessage?: string
    showInfoIcon?: boolean
    className?: string
}

export function PasswordField<TFormValues extends FieldValues>({
    id,
    name,
    label,
    register,
    disabled = false,
    showNewPassword = false,
    onToggleShow,
    errorMessage,
    className = ''
}: PasswordFieldProps<TFormValues>) {
    const hasError = !!errorMessage

    return (
        <div className={className}>
            <label
                htmlFor={id}
                className={`mb-2 text-sm font-semibold tracking-wide  flex items-center${
                    hasError ? 'text-red-01' : 'text-[#1e3a5f]'
                }`}
            >
                {label}
                <span className="text-[#5b9bd5]">
                    {label === 'NEW PASSWORD' && <PasswordResetToolTip />}
                </span>
            </label>

            <div className="relative">
                <input
                    id={id}
                    type={showNewPassword ? 'text' : 'password'}
                    {...register(name)}
                    className={`w-full border-0 border-b ${
                        hasError ? 'border-red-01' : 'border-gray-300'
                    } p-3 pr-10 text-base outline-none`}
                    disabled={disabled}
                />

                <button
                    type="button"
                    onClick={onToggleShow}
                    className="absolute right-2 top-1/2 -translate-y-1/2 cursor-pointer border-none bg-transparent text-lg text-[#5b9bd5]"
                    disabled={disabled}
                >
                    👁
                </button>
            </div>

            {hasError && (
                <div className="text-red-01 text-sm flex items-center justify-end gap-2 text-right">
                    <span>{errorMessage}</span>
                    <TooltipDanger />
                </div>
            )}
        </div>
    )
}
